import React from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/input';

export const CatalogFilters = ({ collections, selected, onSelect, search, onSearch, sort, onSort }) => (
  <div className="mb-8">
    <nav className="premium-filter-tabs" aria-label="Kategorije rasvjete" data-testid="catalog-collections">
      {[{ id: '', name: 'Sva rasvjeta' }, ...collections].map(item => (
        <button key={item.id} type="button" onClick={() => onSelect(item.id)} aria-pressed={selected === item.id}
          className="premium-filter-tab"
          data-testid={`collection-${item.id || 'all'}`}>
          {item.name}{item.id && <span className="ml-2 opacity-70" data-testid={`collection-count-${item.id}`}>{item.count ?? 0}</span>}
        </button>
      ))}
    </nav>
    <div className="premium-catalog-tools">
      <div className="relative w-full sm:max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" aria-hidden="true" />
        <Input type="search" placeholder="Naziv ili šifra proizvoda..." aria-label="Pretražite rasvjetu" value={search} onChange={e => onSearch(e.target.value)} className="pl-10 bg-white" data-testid="webshop-search-input" />
      </div>
      <select value={sort} onChange={e => onSort(e.target.value)} aria-label="Sortiraj proizvode" className="h-10 border border-gray-200 rounded bg-white px-3 text-sm w-full sm:w-auto" data-testid="catalog-sort-select">
        <option value="name">Naziv: A–Ž</option>
        <option value="price_asc">Cijena: od niže</option>
        <option value="price_desc">Cijena: od više</option>
      </select>
    </div>
  </div>
);